
//  Copyright 2023
//  Myriota Pty Ltd
//  Myriota Confidential

import { Button } from "@mui/material";
import Typography from '@mui/material/Typography';
import { createStyles } from '@mui/styles';
import withStyles, { WithStyles } from '@mui/styles/withStyles';
import { Colours as MyColours } from "myriota-common/constant";
import * as React from "react";

const styles = createStyles({
    container: {
        flex: 1,
        display: "flex",
        alignContent: "center",
        alignItems: "center",
        flexDirection: "column",
        paddingTop: "50px"
    },
    error: {
        color: MyColours.ERROR_RED
    },
    footer: {
        marginTop: 24
    },
    button: {
        fontSize: 16,
        fontWeight: "bold",
        border: "none",
        color: MyColours.BLUE_100,
        "&:hover": {
            color: MyColours.BLUE_50,
            backgroundColor: "unset",
        },
    },
    Text: {
        paddingTop: "15px"
    }
});


export interface IPageNotFoundComponentProps extends WithStyles<typeof styles> {
    className?: string;
    history: any; // injected by react-router
}

export class PageNotFoundComponent extends React.Component<IPageNotFoundComponentProps, any> {
    constructor(props: IPageNotFoundComponentProps) {
        super(props);
        this.onButtonClick = this.onButtonClick.bind(this);
    }

    onButtonClick(event: any) {
        this.props.history.push("/")
    }

    render() {
        const cssClasses = this.props.classes;
        return (
            <div className={cssClasses.container}>
                <Typography variant="h1" className={cssClasses.error}>404</Typography>
                <Typography className={cssClasses.Text}>Sorry! The page you requested does not exist.</Typography>
                <div className={cssClasses.footer}>
                    <Button
                        variant="text"
                        onClick={this.onButtonClick}
                        className={cssClasses.button}
                        value="accesstimes"
                    >
                        Home
                    </Button>
                </div>
            </div>
        );
    }
}


export default withStyles(styles)(PageNotFoundComponent);
